module.exports = __webpack_public_path__ + "img/cursive-workbook_B0991C6HZP.d3ca6c8b.jpg";